import { Temporal } from '@js-temporal/polyfill'

export function getDate(): string {
	const timeZone = 'America/Bogota'
	const zonedNow = Temporal.Now.zonedDateTimeISO(timeZone)
	return zonedNow.toInstant().toString() 
}
